import React, { useState } from "react";
import { Layout, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import ChatWidget from "./ChatWidget";

interface DashboardLayoutProps {
  children: React.ReactNode;
  title?: string;
  showNavbar?: boolean;
}

const SIDEBAR_COLLAPSED_KEY = "dashboard-sidebar-collapsed";

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  title = "",
  showNavbar = true,
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true",
  );
  const location = useLocation();
  const showChatWidget = !location.pathname.startsWith("/chat");

  const handleToggleSidebar = () => {
    setSidebarCollapsed((prev) => {
      const nextValue = !prev;
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(nextValue));
      return nextValue;
    });
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <div className="app-shell">
      <div className="dashboard-frame">
        <Layout.Sider
          width={sidebarCollapsed ? 92 : 276}
          trigger={null}
          style={{ background: "transparent" }}
          className="dashboard-rail"
        >
          <Sidebar
            collapsed={sidebarCollapsed}
            onToggleCollapse={handleToggleSidebar}
          />
        </Layout.Sider>

        <Drawer
          open={mobileOpen}
          onClose={handleDrawerToggle}
          placement="left"
          width={292}
          closable={false}
          styles={{
            content: { background: "var(--dashboard-page-bg)" },
            body: { padding: 16, background: "transparent" },
          }}
        >
          <Sidebar onMobileClose={handleDrawerToggle} />
        </Drawer>

        <Layout
          className="dashboard-main-shell"
          style={{ background: "transparent" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
              padding: "14px 20px 0",
            }}
          >
            <Button
              className="mobile-menu-trigger"
              shape="round"
              icon={<MenuOutlined />}
              onClick={handleDrawerToggle}
              aria-label="Abrir menú"
            />
            <Navbar compact />
          </div>

          <Layout.Content
            className="page-spacing"
            style={{ background: "transparent" }}
          >
            <div style={{ width: "100%", minHeight: "100%" }}>{children}</div>
          </Layout.Content>
        </Layout>
      </div>
      {showChatWidget && <ChatWidget />}
    </div>
  );
};

export default DashboardLayout;
